module.exports = __webpack_public_path__ + "static/media/logo.4eb836ff.png";